import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

export enum s3AuthType {
    accessKey = 'AccessKey',
    temporarySecurity = 'TemporarySecurityCredentials'
}

@Metamodel.model({
    name: ModelConstants.amazonS3LinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.AmazonS3_DisplayText),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.AmazonS3_DisplayText)
    ]
})
export class AmazonS3LinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly ACCESS_KEY_ID: IAttribute;
    public static readonly ACCESS_KEY: IAttribute;
    public static readonly SERVICE_URL: IAttribute;
    public static readonly SESSION_TOKEN: IAttribute;
    public authType?: s3AuthType = s3AuthType.accessKey;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AccessKeyID,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'ACCESS_KEY_ID',
        accepts: ['String'],
        templatable: true
    })
    public accessKeyId?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SecretAccessKey,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'ACCESS_KEY',
        templatable: true,
        accepts: ['String']
    })
    public secretAccessKey?: string | AzureKeyVault; // TODO: need a secure type to make sure this won't be exposed to customer.

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServiceUrl,
        association: 'SERVICE_URL',
        templatable: true
    })
    public serviceUrl: string = 'https://s3.amazonaws.com';

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SessionToken,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'SESSION_TOKEN',
        templatable: true,
        accepts: ['String']
    })
    public sessionToken?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
